
<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-4">Career - Applicant</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
          <CButtonGroup>
              <CButton color="secondary" @click="handleChooseStatus(1)">Pendaftaran</CButton>
              <CButton color="secondary" @click="handleChooseStatus(2)">Follow Up</CButton>
              <CButton color="secondary" @click="handleChooseStatus(3)">Accepted</CButton>
              <CButton color="secondary" @click="handleChooseStatus(4)">Hold</CButton>
              <CButton color="secondary" @click="handleChooseStatus(5)">Rejected</CButton>
            </CButtonGroup>
        </CCardHeader>
        
        <CCardBody>
          <table-regitration v-if="statusData === 'NEW'"></table-regitration>
          <table-follow-up v-if="statusData === 'FOLLOW UP'"></table-follow-up>
          <table-accepted v-if="statusData === 'ACCEPT'"></table-accepted>
          <table-hold v-if="statusData === 'HOLD'"></table-hold>
          <table-rejected v-if="statusData === 'REJECT'"></table-rejected>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import Vue from "vue"
import jwt from "jsonwebtoken";
import TableRegstration from "./tables/Registration"
import TableFolowUp from "./tables/FollowUp"
import TableAccepted from "./tables/Accepted"
import TableHold from "./tables/Hold"
import TableRejected from "./tables/Rejected"

Vue.component('table-regitration',TableRegstration)
Vue.component('table-follow-up',TableFolowUp)
Vue.component('table-accepted',TableAccepted)
Vue.component('table-hold',TableHold)
Vue.component('table-rejected',TableRejected)

export default {
  name: "Aplicant",
  data() {
    return {
      statusData:"NEW",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    if(this.$store.getters.getStatusGlobal !== ""){
    this.statusData = this.$store.getters.getStatusGlobal
    }
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        console.log("success");
      } else {
        this.$router.push({ path: `/` });
      }
    },
    handleChooseStatus(event){
        if (event === 1){
        this.statusData = "NEW"
        }else if (event === 2){
        this.statusData = "FOLLOW UP"
        }else if (event === 3){
        this.statusData = "ACCEPT"
        }else if (event === 4){
        this.statusData = "HOLD"
        }else if (event === 5){
        this.statusData = "REJECT"
        }
    },
  }
};
</script>
